import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import App from './App';
import { store } from './redux/store';
import { Provider } from 'react-redux';
import { createTheme } from '@mui/material/styles';
import { ThemeProvider } from '@mui/material';
import {SnackbarProvider} from 'notistack'

const theme = createTheme({
  typography: {
    fontFamily: 'Poppins',
    h5: {
      fontWeight: 'bold'
    },
    // h6: {
    //   fontWeight: 'Medium',
    //   fontSize: '14px'
    // }
  },
});


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // React strict mode is for development only, and causes double rendering of components
  // <React.StrictMode>
    <Provider store={store}>
    <ThemeProvider theme={theme}>
      <SnackbarProvider maxSnack={3} autoHideDuration={5000} preventDuplicate >
       <App />
      </SnackbarProvider>
    </ThemeProvider>
    </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
